module.exports = __webpack_public_path__ + "static/media/img_4_0.d94cf1ed.png";